import { gatewayService } from '../../common/services/gateway';
import { TemplateServiceInterface } from './template.service.interface';
import { Template, TemplateResponse } from './template.service.type';

class TemplateService implements TemplateServiceInterface {
  public async getTemplate(
    vertical: string,
    template_key: string,
  ): Promise<Template> {
    const template = await gatewayService.sendRequest<Template>(
      'GET',
      `template/${vertical}/${template_key}`,
    );
    return template;
  }

  public async useTemplate<T, R>(
    vertical: string,
    template_key: string,
    payload: T,
  ): Promise<TemplateResponse<R>> {
    const mappedPayload = await gatewayService.sendRequest<TemplateResponse<R>>(
      'POST',
      `template/${vertical}/${template_key}`,
      payload,
    );
    return mappedPayload;
  }
}

export const templateService = new TemplateService();
